/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import { IconDownload, IconEye, IconPlus } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ListView from "../../../components/common/ListView";
import ToggleButton from "../../../components/ToggleButton";
import AddTireModal from "./AddTireModal";

const tireData = [
  {
    id: 1,
    tireName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    city: "View Cities",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 2,
    tireName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    city: "View Cities",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 3,
    tireName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    city: "View Cities",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 4,
    tireName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    city: "View Cities",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 5,
    tireName: "MAINI0011234",
    warehouse: "Main",
    country: "Saudi Arabia",
    city: "View Cities",
    date: "4 Aug 2025",
    active: true,
  },
];

export default function TireListTab() {
  const [openZone, setOpenZone] = useState<boolean>(false);
  const openZoneToggleModal = () => {
    setOpenZone(!openZone);
  };

  const [openEditZone, setOpenEditZone] = useState<boolean>(false);
  const openEditZoneToggleModal = () => {
    setOpenEditZone(!openEditZone);
  };

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedWarehouseId, setSelectedWarehouseId] =
    useState<string>("wh123");
  return (
    <>
      <div className="bg-[#F7F6F2] rounded-3xl">
        <div className="flex justify-between items-center w-full p-4">
          <div className="flex justify-between items-center  rounded-tl-3xl rounded-tr-3xl">
            <h1 className="text-3xl text-[#212121]">Tire List</h1>
          </div>
          <div className=" flex items-center gap-2 justify-end rounded-full">
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch />
            </div>
            <button className="flex items-center gap-1 py-2 px-4 text-sm rounded-full border border-[#D8D8D8] bg-white">
              <IconDownload /> Export
            </button>
            <button
              onClick={() => setIsModalOpen(true)}
              className="flex items-center gap-1  p-2 text-sm rounded-full border border-[#D8D8D8] bg-white"
            >
              <IconPlus />
            </button>
          </div>
        </div>
        <div>
          {" "}
          <ListView
            data={tireData}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "S/N", render: (_, i) => i + 1 },
              {
                label: "Zone Name",
                render: (c) => c.tireName,
              },
              {
                label: "Warehouse",
                render: (c) => c.warehouse,
              },
              { label: "Country", render: (c) => c.country },
              {
                label: "City",
                render: () => (
                  <button
                    onClick={openModal}
                    className="underline text-[#007AFF]"
                  >
                    View Cities
                  </button>
                ),
              },
              { label: "Date", render: (c) => c.date },
              {
                label: "Status",
                render: () => <ToggleButton />,
              },
              {
                label: "Actions",
                render: () => (
                  <button className="p-2 border rounded-full bg-[#F7F6F2]">
                    <IconEye />
                  </button>
                ),
              },
            ]}
          />
        </div>
      </div>

      {isModalOpen && (
        <AddTireModal
          selectedWarehouse={selectedWarehouseId}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}
